var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"heading",class:_vm.headingClass},[_c('ScText',{staticClass:"heading__title text-m text-md-m",attrs:{"tag":_vm.headingTag,"field":_vm.fields.HeadingTitle}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }